import { memo } from 'react';
import { MenuItem } from 'consts/openBanking';
import { selectIsExportOpenBankingResourceLoading } from 'features/openBanking/selectors';
import { TableToolbar, type TableToolbarProps } from 'ui/widgets/Table';

const IbanXSToolbar = (props: Pick<TableToolbarProps, 'onExport'>) => (
    <TableToolbar
        {...props}
        selectIsExportLoading={selectIsExportOpenBankingResourceLoading(MenuItem.IbanXS)}
        dataTestIdPrefix='openBanking.table'
    />
);

export default memo(IbanXSToolbar);
